<template>
    <div :key="keyD" class="raptors-group">
        <h2 class="title">{{$t('menu.analysis.analysis')}}</h2>
        <div class="select-container" v-if="this.salons.length > 0 && loaded">
            <!--            <h4>Salony</h4>-->
            <VueMultiselect :close-on-select="true"
                            :deselectLabel="$t('multiselect.deselectLabel')" :multiple="true"
                            :options="salons"
                            :placeholder="$t('multiselect.placeholder')"
                            :selectLabel="$t('multiselect.selectLabel')"
                            :selectedLabel="$t('multiselect.selectedLabel')"
                            label="name"
                            track-by="id"
                            v-model="selectedSalons"
                            :limit="15"
                            :limit-text=" count => `+ ${count}`"
            ></VueMultiselect>
        </div>
        <div class="charts-container container" v-if="this.salons.length > 0">
            <div class="top">
                <h4>{{$t('general.entriesCount')}}</h4>
            </div>
            <div class="controls" v-if="loaded && loadedTable">
                <div class="date-control">
                    <button :class="{active: selectedPredef === 'counters'}" @click="selectedPredef = 'counters'
                            startDate = dates.today.startDate
endDate = dates.today.endDate;
">
                        {{$t('general.today')}}
                    </button>
                    |
                    <button :class="{active: selectedPredef === 'countersYesterday'}"
                            @click="selectedPredef = 'countersYesterday'
                            startDate = dates.yesterday.startDate
endDate = dates.yesterday.endDate;
">{{$t('general.yesterday')}}
                    </button>
                    |
                    <button :class="{active: selectedPredef === 'countersWeek'}"
                            @click="selectedPredef = 'countersWeek'
                            startDate = dates.week.startDate
endDate = dates.week.endDate;

">{{$t('general.week')}}
                    </button>
                    |
                    <button :class="{active: selectedPredef === 'countersMonth'}"
                            @click="selectedPredef = 'countersMonth'
                            startDate = dates.month.startDate
endDate = dates.month.endDate;
">{{$t('general.month')}}
                    </button>
                    |
                    <div class="picker-container">
                        <span class="active">{{$t('general.from')}}:</span>
                        <md-datepicker :md-disabled-dates="fromBlocker" @md-closed="selectedPredef='period'"
                                       md-immediately
                                       v-model="startDate">
                        </md-datepicker>
                    </div>

                    <div class="picker-container">
                        <span class="active">{{$t('general.to')}}:</span>
                        <md-datepicker :md-disabled-dates="gateKeeper" @md-closed="selectedPredef='period'"
                                       md-immediately v-model="endDate"></md-datepicker>
                    </div>
                </div>
                <SubmitButton :button-text="$t('buttons.refresh')" @save="loadData" class="refresh"></SubmitButton>
                <div :title="$t('general.printPDF')" @click="printCharts" class="link print">
                    <img src="../../assets/images/print.svg">
                    <span>{{$t('general.printPDF')}}</span>
                </div>
                <button :title="$t('general.downloadCSV')" @click="downloadCSV" class="link download"><img
                        src="../../assets/images/download.svg"><span>{{$t('general.downloadCSV')}}</span>
                </button>
                <ChartSwitcher :currentState="state" @changeChart="changeChart"></ChartSwitcher>

            </div>
            <div class="charts" v-if="loaded">
                <bar-chart :chart-data="chartData"
                           :height="chartHeight" :options="style"
                           v-if="state===0 && predefinedChartData && loaded"></bar-chart>
                <line-chart :chart-data="lineData" :height="lineChartHeight" :key="chartKey" :options="lineStyle"
                            v-if="state===1 && loaded"></line-chart>
            </div>
            <Preloader v-if="!loaded"></Preloader>
        </div>
        <div class="table-container" v-if="this.salons.length > 0">
            <table class="table" id="counts-table" v-if="loadedTable">
                <thead>
                <tr class="tr">
                    <th class="td" v-for="head in newTable.head">{{head}}</th>
                </tr>
                </thead>
                <tbody>
                <tr class="tr" v-for="row in newTable.rows">
                    <td class="td" v-for="elem in row">{{elem}}</td>
                </tr>
                </tbody>
            </table>
            <Preloader v-else></Preloader>
            <table class="table" id="print-table" style="display: none;">
                <thead>
                <tr class="tr">
                    <th class="td" v-for="head in printData.headers">{{head}}</th>
                </tr>
                </thead>
                <tbody>
                <tr class="tr" v-for="row in printData.rows">
                    <td class="td" v-for="elem in row">{{elem}}</td>
                </tr>
                </tbody>
            </table>

        </div>
        <h2 class="title" v-else>{{$t('messages.noSalons')}}</h2>
        <div :class="`printable-chart`" :id="`printable-chart-${index}`" class="printable-charts"
             v-for="(chart,index) in printChartData"
             v-if="printing">
            <bar-chart :chart-data="chart" :height="600" :options="printStyle"></bar-chart>
        </div>
        <Preloader class="printing" v-if="printing"></Preloader>
    </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect/src/Multiselect';
import JsonCSV from 'vue-json-csv';
import jsPDF from 'jspdf';
import LineChart from '@/components/charts/LineChart.js';
import BarChart from '@/components/charts/BarChart.js';
import {RepositoryFactory} from '@/api/RepositoryFactory';
import Preloader from '@/components/helpers/Preloader';
import ChartSwitcher from '@/components/helpers/ChartSwitcher';
import CountsTable from '@/components/helpers/CountsTable';
import 'vue-material/dist/vue-material.min.css';
import 'jspdf-autotable';
import XLSX from 'xlsx';
import SubmitButton from "@/components/helpers/SubmitButton";

const DataRepository = RepositoryFactory.get('data');
const SalonsRepository = RepositoryFactory.get('salons');

export default {
  name: 'Analysis',
  components: {
    SubmitButton,
    CountsTable,
    ChartSwitcher,
    VueMultiselect,
    Preloader,
    BarChart,
    LineChart,
    JsonCSV,
  },
  data() {
    return {
      maxChartValue: 200,
      chartKey: 0,
      printing: false,
      printChartData: [],
      printData: {
        headers: [this.$t('analysis.hours'), 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        rows: [],
      },
      tableCSVData: [],
      value: [],
      loadedTable: false,
      state: 0,
      tableFilter: 'daysHoursPeriod',
      // options: [],
      startDate: '',
      endDate: '',
      selectedSalons: [],
      // salons: [],
      loaded: false,
      today: '',
      currentDay: '',
      delimiter: this.$store.getters.delimiter,
      total: 0,
      barData: {},
      linData: [],
      newTable: {},
      translatable: false,
      selectedPredef: 'counters',
      predefinedChartData: {
        period: {
          labels: ['loading'],
        },
      },
      lineData: {
        labels: ['loading'],
        data: [0],
      },
      dates: {
        today: {
          startDate: '',
          endDate: '',
        },
        yesterday: {
          startDate: '',
          endDate: '',
        },
        week: {
          startDate: '',
          endDate: '',
        },
        month: {
          startDate: '',
          endDate: '',
        },
      },
      barTitle: '',
      keyD: 0,

      gateKeeper: (date) => {
        const blockedDate = new Date(this.startDate);
        blockedDate.setHours(0, 0, 0);
        const today = new Date().setHours(0, 0, 0);
        if (date < blockedDate || date > today) {
          return true;
        }

        return false;
      },
      fromBlocker: (date) => {
        const today = new Date();
        if (date > today) {
          return true;
        }
        return false;
      },
    };
  },
  computed: {
    language() {
      return this.$i18n.locale;
    },
    lineChartHeight() {
      const hypothetical = this.chartHeight / 8;
      if (hypothetical > 320) {
        return hypothetical;
      }
      return 320;
    },
    group() {
      return this.$store.getters.selectedGroup.id;
    },
    lineStyle() {
      return {
        title: {
          display: true,
          text: `${this.$t('general.reportsTitles.titles.line.1') + this.startDate} - ${this.endDate}`,
        },
        height: 320,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('general.hour'),
            },
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('general.counts'),
            },
          }],
        },
      };
    },
    selectedSalonsString() {
      let list = '';
      this.selectedSalons.forEach((v) => {
        list += `${v.id},`;
      });
      return list;
    },
    style() {
      return {
        title: {
          display: true,
          text: this.barTitle,
        },
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: 50,
            right: 50,
            top: 50,
            bottom: 50,
          },
        },
        scales:
          {
            xAxes: [{
              minBarLength: 2,
              gridLines: {
                offsetGridLines: true,
              },
              ticks: {
                beginAtZero: true,
                min: 0,
              },
            }],
            yAxes:
              [{
                yAxes: [{
                  barPercentage: 0.95,
                  categoryPercentage: 1.0,
                  ticks: {
                    beginAtZero: true,
                    min: 0,
                  },
                },
                ],
              }],
          },
      };
    },
    printStyle() {
      return {
        maintainAspectRatio: false,
        title: {
          display: true,
          text: this.barChartTitle,
        },
        layout: {
          padding: {
            left: 50,
            right: 50,
            top: 50,
            bottom: 50,
          },
        },
        scales:
          {
            xAxes: [{
              minBarLength: 2,
              gridLines: {
                offsetGridLines: true,
              },
              ticks: {
                beginAtZero: true,
                min: 0,
                max: Math.ceil(this.maxChartValue / 100) * 100,
              },
            }],
            yAxes:
              [{
                yAxes: [{
                  barPercentage: 0.95,
                  categoryPercentage: 1.0,
                  ticks: {
                    beginAtZero: true,
                    min: 0,
                  },
                },
                ],
              }],
          },
      };
    },
    chartHeight() {
      if (this.chartData.labels.length) {
        const hypothetical = this.chartData.labels.length * 75;
        if (hypothetical > 320) {
          return hypothetical;
        }
      }
      return 320;
    },
    styleObject() {
      return this.$store.getters.cssConfig;
    },
    chartData() {
      if (this.loaded) {
        return this.predefinedChartData.period;
      }
      return [];
    },
    salons() {
      const { salons } = this.$store.getters;
      this.selectedSalons = salons;
      return salons;
    },
  },
  watch: {
    language() {
      if (this.loaded) {
        this.barTrans = this.$t('general.reportsTitles.titles.bar.1');
      }
    },
    async group(newV) {
      if (this.loaded) {
        this.salons = await SalonsRepository.getShopsGroup(this.$store.getters.token, newV);
        this.selectedSalons = this.salons;
        if (this.salons.length > 0) {
          await this.loadData();
        }
      }
    },
  },
  async mounted() {
    this.$store.commit('set_api_call', true);
    this.$material.locale = {
      startYear: 1900,
      endYear: 2099,
      dateFormat: 'yyyy-MM-dd',
      firstDayOfAWeek: 0,
      days: this.$t('datepicker.days'),
      shortDays: this.$t('datepicker.shortDays'),
      shorterDays: this.$t('datepicker.shorterDays'),
      months: this.$t('datepicker.months'),
      shortMonths: this.$t('datepicker.shortMonths'),
      shorterMonths: this.$t('datepicker.shorterMonths'),
    };
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    const yyyy = today.getFullYear();
    const nextWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() + -7);
    const prevMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
    const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() + -1);

    this.today = `${yyyy}-${mm}-${dd}`;
    this.dates.today.startDate = this.today;
    this.dates.today.endDate = this.today;
    this.dates.month.endDate = this.today;
    this.dates.week.endDate = this.today;
    this.dates.week.startDate = `${nextWeek.getFullYear()}-${String(nextWeek.getMonth() + 1)
      .padStart(2, '0')}-${String(nextWeek.getDate())
      .padStart(2, '0')}`;
    /*   this.dates.month.startDate = `${prevMonth.getFullYear()}-${String(prevMonth.getMonth() + 1)
           .padStart(2, '0')}-${String(prevMonth.getDate())
           .padStart(2, '0')} */
    this.dates.month.startDate = `${yyyy}-${mm}-01`;
    this.dates.yesterday.startDate = `${yesterday.getFullYear()}-${String(yesterday.getMonth() + 1)
      .padStart(2, '0')}-${String(yesterday.getDate())
      .padStart(2, '0')}`;
    this.dates.yesterday.endDate = this.dates.yesterday.startDate;

    this.currentDay = `${yyyy}-${mm}-${dd}`;
    this.startDate = this.dates.today.startDate;
    this.endDate = this.dates.today.endDate;
    await this.getData(this.selectedSalonsString, this.startDate, this.endDate);
    await this.getChartData(this.selectedSalonsString, this.startDate, this.endDate);
    this.loadedTable = true;
    this.loaded = true;
    this.$store.commit('set_api_call', false);
  },
  methods: {
    async loadData() {
      this.switchLoadState();
      this.$store.commit('set_api_call', true);
      const stateBuffer = this.state;
      await this.getChartData(this.selectedSalonsString, this.startDate, this.endDate);
      await this.getData(this.selectedSalonsString, this.startDate, this.endDate);
      this.state = stateBuffer;
      this.chartKey += 1;
      this.$store.commit('set_api_call', false);
      this.switchLoadState();
    },
    generateCSVdata() {
      const objectArray = [];
      this.newTable.rows.forEach((row) => {
        const dto = {};
        row.forEach((value, key) => {
          dto[this.newTable.head[key]] = value;
        });
        objectArray.push(dto);
      });
      this.tableCSVData = objectArray;
    },
    switchLoadState() {
      this.loaded = !this.loaded;
      this.tableLoaded = !this.tableLoaded;
    },
    downloadCSV() {
      const wb = XLSX.utils.book_new();
      const tableSheet = XLSX.utils.json_to_sheet(this.tableCSVData);
      XLSX.utils.book_append_sheet(wb, tableSheet, this.$t('general.tableData'));
      if (this.state === 0) {
        Object.keys(this.barData).forEach((v) => {
          const sheet = XLSX.utils.json_to_sheet(this.barData[v]);
          const name = `${this.$t(`general.reportLabels.${v}`)}: ${this.startDate} - ${this.endDate}`;
          XLSX.utils.book_append_sheet(wb, sheet, `${this.$t(`general.reportLabels.${v}`)}: ${this.startDate}-${this.endDate}`);
        });

        XLSX.writeFile(wb, 'barChart.xlsx');
      } else {
        const sheet = XLSX.utils.json_to_sheet(this.linData);
        XLSX.utils.book_append_sheet(wb, sheet, this.$t('general.reportLabels.period'));
        XLSX.writeFile(wb, 'lineChart.xlsx');
      }
    },
    async getChartData(selectedSalons, startDate, endDate) {
      const retrievedData = await DataRepository.getBarChartPeriod(this.$store.getters.token, selectedSalons, startDate, endDate);

      const dataCollection = {
        labels: [],
        datasets: [
          {
            label: this.$t('general.entries'),
            backgroundColor: `${this.styleObject.chartPrimaryColor}99`,
            data: [],
          }, {
            label: this.$t('general.exits'),
            backgroundColor: `${this.styleObject.chartSecondaryColor}78`,
            data: [],
          }, {
            label: this.$t('general.unknowns'),
            data: [],
          },
        ],
      };
      const rawData = [];
      const data = [];
      const entries = [];
      Object.keys(retrievedData.counters).forEach((val) => {
        dataCollection.labels.push(val);
        dataCollection.datasets[1].data.push(retrievedData.counters[val].outAvg);
        dataCollection.datasets[2].data.push(retrievedData.counters[val].unknownAvg);
        entries.push(retrievedData.counters[val].inAvg);
        rawData.push(retrievedData.counters[val].inSum);
        rawData.push(retrievedData.counters[val].outSum);
        rawData.push(retrievedData.counters[val].unknownSum);
        data.push({
          [this.$t('csvHeaders.name')]: val,
          [this.$t('csvHeaders.entries')]: retrievedData.counters[val].inAvg,
          [this.$t('csvHeaders.exits')]: retrievedData.counters[val].outAvg,
          [this.$t('csvHeaders.unknowns')]: retrievedData.counters[val].unknownAvg,
        });
      });
      const color = entries.map(x => `${this.styleObject.chartPrimaryColor}99`);
      color[this.argMax(entries)] = 'red';
      dataCollection.datasets[0] = {
        label: this.$t('general.entries'),
        backgroundColor: color,
        data: entries,
      };
      this.predefinedChartData.period = dataCollection;
      this.barData.period = JSON.parse(JSON.stringify(data));
      this.maxChartValue = rawData[this.argMax(rawData)];
    },
    async getData(selectedSalons, startDate, endDate) {
      const colorArray = ['#f63', '#ffb399', '#f3f', '#ff9', '#00b3e6',
        '#E6B333', '#3366E6', '#999966', '#99FF99', '#b34d4d',
        '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991a',
        '#ff99e6', '#ccff1a', '#ff1a66', '#e6331a', '#3fc',
        '#66994d', '#b366cc', '#4d8000', '#b33300', '#cc80cc',
        '#66664d', '#991aff', '#e666ff', '#4db3ff', '#1ab399',
        '#e666b3', '#33991a', '#c99', '#b3b31a', '#00e680',
        '#4d8066', '#809980', '#e6ff80', '#1aff33', '#993',
        '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900b3',
        '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#66f'];
      const retrievedData = await DataRepository.getAnalysisData(this.$store.getters.token, selectedSalons, startDate, endDate);
      this.printData.rows = [];
      const dataCollection = {
        labels: [],
        datasets: [],
      };
      const table = {
        head: [],
        rows: [],
      };
      table.head.push(this.$t('analysis.hours'));
      Object.keys(retrievedData.rows[Object.keys(retrievedData.rows)[0]].countsData).forEach((val) => {
        dataCollection.labels[val] = val;
        table.rows[val] = [val];
      });
      let k = 0;

      Object.keys(retrievedData.rows).forEach((val) => {
        // eslint-disable-next-line eqeqeq
        const currentSalon = this.selectedSalons.find(salon => salon.name === val);

        if (currentSalon !== undefined) {
          const dataset = {
            label: currentSalon.name,
            data: [],
            borderColor: colorArray[k],
          };
          table.head.push(currentSalon.name);
          const tdo = [currentSalon.name];
          Object.keys(retrievedData.rows[val].countsData).forEach((value) => {
            dataset.data[value] = retrievedData.rows[val].countsData[value];
            table.rows[value].push(retrievedData.rows[val].countsData[value]);
            tdo.push(retrievedData.rows[val].countsData[value]);
          });

          this.printData.rows.push(tdo);
          dataCollection.datasets.push(dataset);
          k += 1;
          if (k > colorArray.length - 1) {
            k = 0;
          }
          const flatData = {};
          flatData[this.$t('csvHeaders.name')] = currentSalon.name;

          dataset.data.forEach((w, key) => {
            flatData[key] = w;
          });
          this.linData.push(flatData);
        }
      });
      // this.printData.rows.push([this.$t('analysis.average'), ...retrievedData.summary.countsDataAvg]);
      const ato = [this.$t('analysis.average')];
      table.head.push(this.$t('analysis.average'));
      Object.keys(retrievedData.summary.countsDataAvg).forEach((val) => {
        table.rows[val].push(retrievedData.summary.countsDataAvg[val]);
        ato.push(retrievedData.summary.countsDataAvg[val]);
      });
      this.printData.rows.push(ato);
      this.newTable = table;
      this.generateCSVdata();
      this.lineData = dataCollection;
    },
    argMax(array) {
      return array.map((x, i) => [x, i]).reduce((r, a) => (a[0] > r[0] ? a : r))[1];
    },
    generatePrintedCharts() {
      const elements = this.barData.period;
      const elementsCount = this.barData.period.length;
      const pages = Math.ceil(elementsCount / 15);
      let n = 0;
      for (n = 0; n < pages; n += 1) {
        const dto = {
          labels: [],
          datasets: [
            {
              label: this.$t('general.entries'),
              backgroundColor: `${this.styleObject.chartPrimaryColor}99`,
              data: [],
            }, {
              label: this.$t('general.exits'),
              backgroundColor: `${this.styleObject.chartSecondaryColor}78`,
              data: [],
            },
            {
              label: this.$t('general.unknowns'),
              data: [],
            },
          ],
        };
        for (let i = 0; i < 15; i += 1) {
          const index = (14 * n) + i;
          const data = elements[index];
          if (data !== undefined) {
            dto.labels.push(data[this.$t('csvHeaders.name')]);
            dto.datasets[0].data.push(data[this.$t('csvHeaders.entries')]);
            dto.datasets[1].data.push(data[this.$t('csvHeaders.exits')]);
            dto.datasets[2].data.push(data[this.$t('csvHeaders.unknowns')]);
          }
        }
        this.printChartData.push(dto);
      }
      return pages;
    },
    async printCharts() {
      // this.printing = true;
      const font = require('@/styles/font.json');
      const canvasEle = [];
      if (this.state === 0) {
        this.chartCount = this.generatePrintedCharts();
        this.keyD += 1;
      }
      this.$nextTick(() => {
        const doc = new jsPDF({
          orientation: 'landscape',
          compress: true,
        });
        doc.addFileToVFS('nunito.ttf', font.nunito);
        doc.addFont('nunito.ttf', 'nunito', 'normal');
        doc.setFont('nunito', 'normal');
        doc.setFontSize(12);
        if (this.state === 0) {
          for (let i = 0; i < this.chartCount; i += 1) {
            canvasEle.push(document.getElementById(`printable-chart-${i}`).getElementsByTagName('canvas')[0]);
          }
        } else {
          canvasEle.push(document.getElementById('line-chart'));
        }
        setTimeout(() => {
          canvasEle.forEach((value, index) => {
            const imgData = value.toDataURL('image/jpg', 1.0);
            doc.addImage(imgData, 'JPEG', 30, 10, 250, 150, '', 'FAST');
            if (index < canvasEle.length - 1) {
              doc.addPage();
            }
          });
          doc.autoTable({
            html: '#print-table',
            startY: 100,
            rowPageBreak: 'auto',
            pageBreak: 'always',
            styles: {
              font: 'nunito',
              fontStyle: 'normal',
              fontSize: 6,
              cellWidth: 3,
              rowPageBreak: 'auto',
              pageBreak: 'always',
            },
          });
          doc.save();
          this.printing = false;
        });
      });
    },
    changeChart() {
      if (this.state === 0) {
        this.state = 1;
      } else {
        this.state = 0;
      }
    },
    getImgUrl() {
      return require('@/assets/images/weather/04.svg');
    },
  },

};
</script>


<style lang="scss" scoped>
    a {
        text-decoration: none;
        font-weight: bold;

        &:visited {
            color: #002678;
        }
    }

    button {
        cursor: pointer;
        text-transform: capitalize;
    }

    .switcheroo {
        align-items: center;
        display: flex;

        img {
            padding: 20px;
        }
    }

    .raptors-group {
        /*width: 100%;*/
        padding-left: 40px;
        padding-right: 55px;
        @include media('<1026px') {
            padding: 0;
        }
    }

    .top {
        margin-bottom: 20px;

        button {
            margin: 10px;
        }
    }

    .table-container {

        .top {
            margin-bottom: 20px;
            display: flex;
            padding: 25px;
            align-items: center;

            button {
                margin: 10px;
            }
        }
    }

    .charts-container, .table-container {
        background: white;
        border-radius: 5px;
        padding: 20px 0;
        margin-top: 50px;
        margin-bottom: 50px;

        .top {
            margin-bottom: 20px;
        }

        .controls {
            border-top: 1px solid #e5e5e5;
            border-bottom: 1px solid #e5e5e5;
            padding: 40px 50px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
        }

        .charts {
            max-height: 320px;
            overflow-y: auto;
        }

    }

    .link {
        display: flex;
        justify-content: space-between;
        align-items: center;

        img {
            margin-right: 15px;
        }
    }

    h4 {
        font-size: rem(16px);
        font-weight: bold;
        // color: $baseTextColor;
        text-transform: uppercase;
        text-align: left;
        margin-left: 33px;
        margin-top: 0;
    }

    /* The switch - the box around the slider */
    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #9e9e9e;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: #002678;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: #9e9e9e;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #9e9e9e;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }

    .date-control {
        /* color: #878a94; */
        font-size: rem(14px);
        font-weight: 900;
        display: flex;
        flex-wrap: wrap;
        align-items: center;

    }

    button {
        background: none;
        border: none;
        font-size: rem(14px);
        font-weight: 900;
        /* color: #878a94; */
        color: inherit;
        text-transform: capitalize;

        &:hover {
            color: $peacock-blue;
        }

    }

    .link.download {
        font-weight: normal;

        > div {
            display: flex;
            align-items: center;
            cursor: pointer;
        }

        text-transform: capitalize;

        &:hover {
            color: $peacock-blue;
        }
    }

    .link.print {
        cursor: pointer;
        text-transform: capitalize;

        &:hover {
            color: $peacock-blue;
        }
    }

    .active {
        color: $peacock-blue;
    }

    .picker-container {
        padding-left: 15px;
        display: flex;
        align-items: center;
        color: $peacock-blue !important;

        input {
            color: $peacock-blue !important;
        }

    }

    table {
        width: 95%;
        margin: 0 auto;
        border-collapse: collapse;
    }

    .table {
        box-shadow: none;
    }

    thead {
        &:first-child {
            .td {
                border: none;
                border-bottom: 1px solid $border-blue;
                font-weight: 900;
            }
        }
    }

    .tr {
        text-align: left;

        .td {
            padding: 13px;
            border: 1px solid $border-gray;
            border-top: none;

            &:last-child {
                border-right: none;
            }

            &:first-child {
                border-left: none;
            }
        }


    }

    .table-container {
        overflow-x: auto;
    }

    .printing {
        height: 100vh;
        width: 100vw;
        position: fixed;
        background-color: white;
        top: 0;
        left: 0;
        z-index: 20000;
    }

    .save {
        padding: 10px 15px;
        color: white;
        border-radius: 15px;
        margin: 0 10px;
        font-weight: bold;
        text-transform: capitalize;
    }

    .refresh::v-deep {
        button.save {
            padding: 10px 15px !important;
            font-size: rem(15px) !important;
        }
    }
</style>
